export class KeysEstaticas {
  // Token
  public static TOKEN_USERLOGIN = 'userLogin';

  // Session
  public static SESSION_MODULO = 'listModulosSession';
  public static SESSION_IDIOMA = 'idiomaUser';
  public static SESSION_NOTIFICACIONES = 'numNotificaciones';
  public static SESSION_VER_NOTIFICACIONES = 'verNotificaciones';
  public static SESSION_CENTROT_RABAJO = 'centroTrabajo';

  // Tipos de previsión
  public static PREVISISION_ESTANDAR = 'estándar';
  public static PREVISISION_PEDIDO_INTERNO = 'pedidoInterno';

  // Tipos de perfiles
  public static PERFIL_CLIENTE = 'cliente';
  public static PERFIL_DISTRIBUIDOR = 'distribuidor';
  public static PERFIL_PROVEEDOR = 'proveedor';
  public static PERFIL_TRANSPORTE = 'transporte';

  // Session listados autorizaciones
  public static LIST_AUTORIZACION = 'autorizacionesSession';
  public static LIST_AUTORIZACION_FILTRO = 'autorizacionesFiltroSession';

  public static LOGIN_NUM_INTENTOS = 3;
  public static LOGIN_NUM_MINUTOS_BLOQUEO = 5;

}
